import React, { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Grid } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import { push } from 'react-router-redux';
import { get, has, isEmpty } from 'lodash';
import axios from 'axios';
import GoogleLogin from 'react-google-login';

// import { HHMultipleSelect } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import {
  handleResponseCode,
  signUp,
  accountSignUp,
  fetchTags,
  googleLogin,
  resetGithubState,
  resetLinkedinState,
  cancelSocialLogin
} from '../actions';
import { Input } from '../../uiStandard/event/input';
import { Dropdown } from '../../uiStandard/event/dropdown';
import { OrginalButton } from '../../uiStandard/event/button';
import { Checkbox } from '../../uiStandard/event/checkbox';
import { FormSubmitButton } from '../../uiStandard/event/formInput';
import { MultipleSelect } from '../../uiStandard/event/multipleSelect';
import { HHAlert, hlog } from '../common/util';
import { ALERT_TYPE } from '../common/constant';
import { DUPLICATE_EMAIL_CHECK, SEND_VERIFICATION_EMAIL, VALIDATE_EMAIL_CODE } from '../network/api';
import { CONFIG } from '../../config';

window.recaptchaOptions = {
  useRecaptchaNet: true
};

const formikEnhancer = withFormik({
  enableReinitialize: true,
  validationSchema: ({ translate }) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{6,}$/;

    const validationShape = {
      email: Yup.string()
        .email(translate('form.error.string.email'))
        .required(translate('form.error.mixed.required')),
      firstName: Yup.string()
        .strict(false)
        .trim(translate('form.error.validate.trim'))
        .min(1, translate('form.error.string.min'))
        .max(30, translate('form.error.string.max'))
        .matches(/^[A-Za-z]+$/, translate('form.error.validate.letterOnly'))
        .required(translate('form.error.mixed.required')),
      lastName: Yup.string()
        .strict(false)
        .trim(translate('form.error.validate.trim'))
        .min(1, translate('form.error.string.min'))
        .max(30, translate('form.error.string.max'))
        .matches(/^[A-Za-z]+$/, translate('form.error.validate.letterOnly'))
        .required(translate('form.error.mixed.required')),
      password: Yup.string()
        .when('isSocialLogin', {
          is: false,
          then: Yup.string()
            .trim(translate('form.error.validate.trim'))
            .min(6, translate('form.error.string.min'))
            .max(30, translate('form.error.string.max'))
            .matches(passwordRegex, translate('form.error.validate.password'))
            .required(translate('form.error.mixed.required'))
        }),
      confirmPassword: Yup.string()
        .when('isSocialLogin', {
          is: false,
          then: Yup.string().required(translate('form.error.mixed.required')).oneOf([Yup.ref('password')], translate('form.error.mixed.matchPasswords'))
        }),
      signupRole: Yup.string()
        .required(translate('form.error.mixed.required')),
      emailVerificationCode: Yup.string()
        .when('isSocialLogin', {
          is: false,
          then: Yup.string()
            .required(translate('form.error.mixed.required'))
            .matches(/^[0-9]+$/, translate('form.error.validate.mustDigitOnly'))
            .min(6, translate('form.error.validate.digitOnly'))
            .max(6, translate('form.error.validate.digitOnly'))
        }),
      username: Yup.string().trim()
        .required(translate('form.error.mixed.required'))
        .min(1, translate('form.error.string.min'))
        .max(25, translate('form.error.string.max'))
        .matches(/^[a-zA-Z0-9]+$/
          , translate('form.error.validate.alphabetAndIntOnly')),
      tags: Yup.array()
        .min(1, translate('form.error.array.min'))
        .max(5, translate('form.error.array.max'))
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required()
          })
        ),
      isSocialLogin: Yup.boolean(),
      newsletterSubscription: Yup.boolean()
    };
    return Yup.object().shape(validationShape);
  },
  mapPropsToValues: ({ user }) => ({
    email: user.thirdPartyEmail || '',
    firstName: user.thirdPartyFirstName || '',
    lastName: user.thirdPartyLastName || '',
    newsletterSubscription: false,
    googleTokenId: user.googleTokenId || '',
    isSocialLogin: false
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    setSubmitting(true);
    if (isEmpty(values.username) || isEmpty(values.signupRole)) {
      setSubmitting(false);
      HHAlert({ id: 'alert.error.fillInRequiredFields' }, ALERT_TYPE.ERROR);
      return;
    }
    const formData = { ...values };
    if (props.user.thirdPartyIdentification && props.user.thirdPartyFrom) {
      formData.thirdPartyType = props.user.thirdPartyFrom;
      formData.thirdPartyIdentification = String(props.user.thirdPartyIdentification);
    }

    props.accountSignUp(formData).then(signUpFinished => {
      if (!signUpFinished) setSubmitting(false);
    });
  },
  displayName: FORM_NAME.SIGNUP_FORM
});

const onChange = (value, values) => {
  values.captchaValue = value;
};

const NameInput = styled(Input)`
  width: 160px;

  @media (max-width: 768px) {
    width: auto;
  }
`;

const RegularInput = styled(Input)`
  width: 338px;

  @media (max-width: 768px) {
    width: auto;
  }
`;

const UserRoleSelect = styled(Dropdown)`
  width: 338px;
  @media (max-width: 768px) {
    width: auto;
  }
`;
// width: auto;
const VerificationCodeInput = styled(Input)`
  &&&&&& {
    min-width: 200px;
    width: 100%;
  }
`;

const NewletterSubCheckbox = styled(Checkbox)`
  width: auto;

`;

const AccountSignupForm = props => {
  const {
    translate,
    handleSubmit,
    activeLanguage,
    values,
    setSignupPhase,
    signupPhase,
    setFieldValue,
    isSubmitting,
    setSubmitting,
    errors
  } = props;

  const [tagOptions, setTagOptions] = useState([]);
  const [sendVerificationCodeEnabled, setSendVerificationCodeEnabled] = useState(true);
  const [sendCodeButtonText, setSendCodeButtonText] = useState('');
  const [isSocialLogin, setIsSocialLogin] = useState(false);

  const updateEverySecBeforeResend = (i) => {
    if (i !== 60) {
      setSendCodeButtonText(`${60 - i}${translate('seconds')}`);
    } else {
      setSendCodeButtonText(props.translate('form.label.sendVerificationEmail'));
      setSendVerificationCodeEnabled(true);
    }
  };

  const sendVerificationCode = async () => {
    if (!has(values, 'email') || isEmpty(get(values, 'email'))) {
      HHAlert({ id: 'alert.error.fillInRequiredFields' }, ALERT_TYPE.ERROR);
      return;
    }
    try {
      const res = await axios.post(SEND_VERIFICATION_EMAIL, { hhe: true, email: get(values, 'email') });
      const { data } = res;
      handleResponseCode(data.code);
      const { response } = data;
      if (get(data, 'code') === 200 && has(response, 'tmpCode') && !isEmpty(get(response, 'tmpCode'))) {
        setFieldValue('tmpCode', get(response, 'tmpCode'));
        HHAlert({ id: 'alert.success.verificationEmailSent' }, ALERT_TYPE.SUCCESS);
      }
    } catch (err) {
      hlog(err);
    }
  };

  const verifyEmailCode = async () => {
    const { tmpCode, emailVerificationCode, email } = values;
    try {
      const res = await axios.post(VALIDATE_EMAIL_CODE, { email, verificationCode: emailVerificationCode, tmpCode });
      const { data } = res;
      handleResponseCode(data.code);
      return get(data, 'code') === 200;
    } catch (err) {
      hlog(err);
      return false;
    }
  };

  const sendAutoVerificationEmail = async () => {
    setSendVerificationCodeEnabled(false);
    await sendVerificationCode();
    for (let i = 0; i <= 60; i += 1) {
      setTimeout(() => updateEverySecBeforeResend(i), i * 1000);
    }
    setSendCodeButtonText(translate('form.label.sendVerificationEmail'));
  };

  const handleSendVerificationEmailClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSendVerificationCodeEnabled(false);
    await sendVerificationCode();
    for (let i = 0; i <= 60; i += 1) {
      setTimeout(() => updateEverySecBeforeResend(i), i * 1000);
    }
    setSendCodeButtonText(translate('form.label.sendVerificationEmail'));
  };

  const checkEmailTaken = async (email) => {
    try {
      const res = await axios.post(DUPLICATE_EMAIL_CHECK, { email });
      const { data } = res;
      handleResponseCode(data.code);
      if (data.code === 200) {
        return true;
      } return false;
    } catch (err) {
      hlog(err);
      return false;
    }
  };

  const handleNextStep = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setSubmitting(true);
    switch (signupPhase) {
      // eslint-disable-next-line no-case-declarations
      case 0:
        if (isEmpty(values.email) || isEmpty(values.firstName) || isEmpty(values.lastName)) {
          HHAlert({ id: 'alert.error.fillInRequiredFields' }, ALERT_TYPE.ERROR);
          setSubmitting(false);
          return;
        }
        if (!isSocialLogin) {
          if (isEmpty(values.password) || isEmpty(values.confirmPassword)) {
            HHAlert({ id: 'alert.error.fillInRequiredFields' }, ALERT_TYPE.ERROR);
            setSubmitting(false);
            return;
          }
          if (get(values, 'password') !== get(values, 'confirmPassword')) {
            HHAlert({ id: 'alert.error.passwordNotMathed' }, ALERT_TYPE.ERROR);
            setSubmitting(false);
            return;
          }
        }
        // check if email is taken
        const isEmailUnique = await checkEmailTaken(get(values, 'email'));
        if (!isEmailUnique) {
          setSubmitting(false);
          return;
        }
        // set default username
        setFieldValue('username', `${values.firstName}${values.lastName}`);

        // SEND VERIFICATION CODE HERE: check if it has been 1 minute since the last click
        if (sendVerificationCodeEnabled && !isSocialLogin) {
          sendAutoVerificationEmail();
        }
        break;
      // eslint-disable-next-line no-case-declarations
      case 1:
        if (isEmpty(values.tmpCode) || isEmpty(values.emailVerificationCode)) {
          HHAlert({ id: 'alert.error.fillInRequiredFields' }, ALERT_TYPE.ERROR);
          setSubmitting(false);
          return;
        }
        const codeCheckPassed = await verifyEmailCode();
        if (!codeCheckPassed) {
          setSubmitting(false);
          return;
        }
        break;
      case 2:
        if (isEmpty(values.captchaValue)) {
          HHAlert({ id: 'alert.error.passGoogleRecaptchaFirst' }, ALERT_TYPE.ERROR);
          setSubmitting(false);
          return;
        }
        break;
      default:
        break;
    }

    setSubmitting(false);
    // email verification is not required for user from social login
    if (signupPhase === 0 && isSocialLogin) {
      setSignupPhase(signupPhase + 2);
    } else if (signupPhase < 2) {
      setSignupPhase(signupPhase + 1);
    }
  };

  const toLogin = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.push('/login');
  };

  const toPolicy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.push('/signup_policy');
  };

  const styles = {
    gridRowPadding: {
      paddingTop: '7px',
      paddingBottom: '7px'
    }
  };

  const getBlurredUserEmail = () => {
    if (has(values, 'email') && get(values, 'email')) {
      if (!get(values, 'email').includes('@')) {
        return '';
      }
      const [prefix, domain] = [get(values, 'email').split('@')[0], get(values, 'email').split('@')[1]];
      if (prefix.length > 3) {
        return `${prefix.substring(0, 3)}***@${domain}`;
      } return `${prefix[0]}**@${domain}`;
    } return '';
  };

  const googleLogin = (googleUser) => {
    setSubmitting(true);
    const payload = {
      id: googleUser.getBasicProfile().getId(),
      email: googleUser.getBasicProfile().getEmail(),
      from: 'Google',
      firstName: googleUser.getBasicProfile().getGivenName() || '',
      lastName: googleUser.getBasicProfile().getFamilyName() || ''
    };

    props.googleLogin(payload, async (res) => {
      const { ifHHAccWithSameEmailExist } = res;
      if (has(res, 'correctThirdPartyPlatform') && get(res, 'correctThirdPartyPlatform')) {
        HHAlert({ id: `alert.error.incorrectThirdPartyPlatform${get(res, 'correctThirdPartyPlatform')}` }, ALERT_TYPE.ERROR);
        // wait for 3s for participants to view the error content
        await new Promise(r => setTimeout(r, 3000));
        props.push('/login');
      } else if (ifHHAccWithSameEmailExist) {
        // for now disable binding hh acc and third party info
        HHAlert({ id: 'alert.error.socialLoginHHAccWithSameEmailExists', context: { email: payload.email } }, ALERT_TYPE.ERROR);
        // wait for 3s for participants to view the error content
        await new Promise(r => setTimeout(r, 3000));
        props.push('/login');
      } else {
        // prefill fields
        // setFieldValue('firstName', payload.firstName);
        // setFieldValue('lastName', payload.lastName);
        setFieldValue('email', payload.email);
        setFieldValue('thirdPartyType', 'Google');
        setFieldValue('thirdPartyIdentification', String(payload.id));
        setFieldValue('password', '');
        setFieldValue('confirmPassword', '');
        setFieldValue('googleTokenId', googleUser.getAuthResponse().id_token);
        setFieldValue('isSocialLogin', true);
        setSubmitting(false);
        setIsSocialLogin(true);
      }
    });
  };

  const genRandomId = () => `_${Math.random().toString(36).substr(2, 9)}`;

  const githubLogin = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const githubState = genRandomId();
    props.resetGithubState(githubState);
    const params = {
      clientId: CONFIG.GITHUB_CLIENT_ID,
      redirectUri: CONFIG.GITHUB_REDIRECT_URL,
      scope: 'read:user&user:email',
      state: githubState,
      allowSignup: false
    };
    const getParams = () => {
      const {
        redirectUri, clientId, scope, state, allowSignup
      } = params;
      const githubAuthenLink = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${encodeURI(scope)}&state=${state}&allow_signup=${allowSignup}`;
      return githubAuthenLink;
    };
    window.open(getParams(), '_self');
  };

  const linkedinLogin = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const linkedinState = genRandomId();
    props.resetLinkedinState(linkedinState);
    const params = {
      clientId: CONFIG.LINKEDIN_CLIENT_ID,
      redirectUri: CONFIG.LINKEDIN_REDIRECT_URL,
      state: linkedinState,
      scope: 'r_liteprofile r_emailaddress',
      supportIE: false
    };
    const getParams = () => {
      const {
        redirectUri, clientId, state, scope, supportIE, redirectPath
      } = params;
      // TODO: Support IE 11
      const scopeParam = (scope) ? `&scope=${supportIE ? scope : encodeURI(scope)}` : '';
      const linkedinAuthenLink = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}${scopeParam}&state=${state}`;
      if (supportIE) {
        const redirectLink = `${window.location.origin}${redirectPath}?linkedin_redirect_url=${encodeURIComponent(linkedinAuthenLink)}`;
        return redirectLink;
      }
      return linkedinAuthenLink;
    };
    window.open(getParams(), '_self');
  };

  const googleSDK = () => {
    window.googleSDKLoaded = () => {
      window.gapi.load('auth2', async () => {
        this.auth2 = await window.gapi.auth2.init({
          client_id: CONFIG.GOOGLE_CLIENT_ID,
          cookiepolicy: 'single_host_origin',
          scope: 'profile email'
        });
      });
    };

    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));
  };

  const cancelSocialLogin = async (e) => {
    e.preventDefault();

    if (!isSocialLogin) {
      return;
    }
    const payload = {
      thirdPartyType: values.thirdPartyType,
      thirdPartyIdentification: String(values.thirdPartyIdentification)
    };
    await props.cancelSocialLogin(payload);

    setFieldValue('email', '');
    setFieldValue('thirdPartyType', '');
    setFieldValue('thirdPartyIdentification', '');
    setFieldValue('password', '');
    setFieldValue('confirmPassword', '');
    setIsSocialLogin(false);
    setFieldValue('isSocialLogin', false);
  };

  const userRolesOptions = [
    {
      content: translate('common.participant'),
      value: 'Participant'
    },
    {
      content: translate('common.organizer'),
      value: 'Organizer'
    }
  ];

  useEffect(() => {
    props.fetchTags();
    const domain = window.location.href;
    if (!domain.includes('event.hackhub.cn') && !domain.includes('localhost')) {
      googleSDK();
    }

    const { user } = props;
    if (user.ifThirdPartyEmailExist && !user.ifHHAccWithSameEmailExist && user.thirdPartyFrom && user.thirdPartyIdentification && user.thirdPartyEmail) {
      setFieldValue('email', user.thirdPartyEmail);
      setFieldValue('thirdPartyType', user.thirdPartyFrom);
      setFieldValue('thirdPartyIdentification', String(user.thirdPartyIdentification));
      setFieldValue('password', '');
      setFieldValue('confirmPassword', '');
      setIsSocialLogin(true);
      setFieldValue('isSocialLogin', true);
    }
    // if run on Cypress
    if (window.Cypress) {
      setFieldValue('captchaValue', 'exampletestercypress1-captcha');
    }
  }, []);

  useEffect(() => {
    setSendCodeButtonText(props.translate('form.label.sendVerificationEmail'));
  }, [props.translate]);

  useEffect(() => {
    setTagOptions(props.tagOptions);
  }, [props.tagOptions]);

  return (
    <Form onSubmit={handleSubmit}>
      <Container>
        { signupPhase === 0 &&
          <Grid>
            <Grid.Row centered style={styles.gridRowPadding}>
              <Title>{translate('form.title.signup')}</Title>
            </Grid.Row>
            <Grid.Row style={styles.gridRowPadding}>
              <Grid.Column
                width={8} computer={8} tablet={8}
                mobile={16} textAlign='left'
              >
                <Form.Field>
                  <Field
                    name='firstName'
                    component={NameInput}
                    otherProps={{
                      id: 'firstName',
                      placeholder: translate('form.placeholder.firstName'),
                      type: 'text',
                      label: `${translate('First Name')}*`
                    }}
                  />
                </Form.Field>
              </Grid.Column>
              <Grid.Column
                width={8} computer={8} tablet={8}
                mobile={16} textAlign='left'
              >
                <Form.Field>
                  <Field
                    name='lastName'
                    component={NameInput}
                    otherProps={{
                      id: 'lastName',
                      placeholder: translate('form.placeholder.lastName'),
                      type: 'text',
                      label: `${translate('Last Name')}*`
                    }}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
            {!isSocialLogin &&
              <Fragment>
                <Grid.Row style={styles.gridRowPadding}>
                  <Grid.Column width={16} textAlign='left'>
                    <Form.Field>
                      <Field
                        name='email'
                        component={RegularInput}
                        otherProps={{
                          id: 'email',
                          placeholder: translate('form.placeholder.emailAddress'),
                          type: 'email',
                          label: `${translate('form.label.emailAddress')}*`
                        }}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={styles.gridRowPadding}>
                  <Grid.Column width={16} textAlign='left'>
                    <Form.Field>
                      <Field
                        name='password'
                        component={RegularInput}
                        otherProps={{
                          id: 'password',
                          placeholder: translate('form.placeholder.password'),
                          type: 'password',
                          label: `${translate('form.label.password')}*`,
                          showPopUp: 'passwordInput'
                        }}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={styles.gridRowPadding}>
                  <Grid.Column width={16} textAlign='left'>
                    <Form.Field>
                      <Field
                        name='confirmPassword'
                        component={RegularInput}
                        otherProps={{
                          id: 'confirmPassword',
                          placeholder: translate('form.placeholder.confirmPassword'),
                          type: 'password',
                          label: `${translate('form.label.confirmPassword')}*`,
                          showPopUp: 'passwordConfirm'
                        }}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
              </Fragment>
            }
            <Grid.Row style={styles.gridRowPadding}>
              <Grid.Column width={16} textAlign='left'>
                <Form.Field>
                  <Field
                    name='newsletterSubscription'
                    component={NewletterSubCheckbox}
                    otherProps={{
                      id: 'newsletterSubscription',
                      label: translate('form.label.newsletterSubscription'),
                      isPrimary: false
                    }}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={styles.gridRowPadding}>
              <Grid.Column width={16} textAlign='center'>
                <AgreePolicyText>
                  {translate('form.label.agreePolicy')}
                </AgreePolicyText>
                <PolicyLink onClick={(e) => toPolicy(e)}>
                  {translate('form.label.policyName')}
                </PolicyLink>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={styles.gridRowPadding}>
              <Grid.Column width={16} textAlign='center'>
                <RegularButton
                  onClick={(e) => handleNextStep(e)}
                  isSubmitting={isSubmitting}
                  label={translate('button.createNewAccount')}
                  type='button'
                  // disabled={has(errors, 'firstName') || has(errors, 'lastName') || has(errors, 'password') || has(errors, 'confirmPassword') || has(errors, 'email')}
                />
              </Grid.Column>
            </Grid.Row>

            {!isSocialLogin ?
              <Fragment>
                <Grid.Row style={styles.gridRowPadding}>
                  <LineBorder />
                  <ThirdPartyText>
                    {translate('form.label.alertnativeSignup')}
                  </ThirdPartyText>
                  <LineBorder />
                </Grid.Row>
                <Grid.Row style={styles.gridRowPadding} className='thirdPartiesCol'>
                  <Grid.Column width={16} textAlign='center'>
                    <GithubIcon onClick={(e) => githubLogin(e)} />
                    {!window.location.hostname.includes('event.hackhub.cn') &&
                      <GoogleLogin
                        clientId={CONFIG.GOOGLE_CLIENT_ID}
                        render={renderProps => (
                          <GoogleIcon onClick={renderProps.onClick} />
                        )}
                        buttonText='Login'
                        onSuccess={res => googleLogin(res)}
                        // onFailure={responseGoogle}
                        cookiePolicy='single_host_origin'
                      />
                    }
                    <LinkedinIcon onClick={(e) => linkedinLogin(e)} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={styles.gridRowPadding}>
                  <Grid.Column width={12} textAlign='center'>
                    <DescriptionText>
                      {translate('form.already.have.account')}
                    </DescriptionText>
                  </Grid.Column>
                  <Grid.Column width={4} textAlign='center'>
                    <LoginRedirect onClick={(e) => toLogin(e)}>
                      {translate('form.login')}
                    </LoginRedirect>
                  </Grid.Column>
                </Grid.Row>
              </Fragment>
              :
              <Grid.Row style={styles.gridRowPadding}>
                <Grid.Column width={16} textAlign='center'>
                  <CancelButton
                    onClick={(e) => cancelSocialLogin(e)}
                    isSubmitting={isSubmitting}
                    label={translate('button.cancelSocialLogin')}
                    isSecondary
                  />
                </Grid.Column>
              </Grid.Row>
            }
          </Grid>
        }
        {
          signupPhase === 1 &&
          <Grid centered>
            <Grid.Row>
              <Title>{translate('form.title.emailVerification')}</Title>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column
                width={9} computer={9} tablet={9}
                mobile={16} textAlign='left' verticalAlign='bottom'
              >
                <Form.Field>
                  <Field
                    name='emailVerificationCode'
                    component={VerificationCodeInput}
                    otherProps={{
                      id: 'emailVerificationCode',
                      placeholder: translate('form.placeholder.emailVerificationCode'),
                      type: 'text',
                      label: `${translate('form.label.emailVerificationCode')}*`
                    }}
                  />
                </Form.Field>
              </Grid.Column>
              <Grid.Column
                width={7} computer={7} tablet={7}
                mobile={16} textAlign='right' verticalAlign='bottom'
              >
                <SendCodeButton
                  isPrimary
                  isSmall
                  onClick={(e) => handleSendVerificationEmailClick(e)}
                  disabled={!sendVerificationCodeEnabled}
                >
                  {sendCodeButtonText}
                </SendCodeButton>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <VerificationDescText>
                  {`${translate('form.label.emailVerificationDescText', { email: getBlurredUserEmail() })}`}
                </VerificationDescText>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16} textAlign='center'>
                <RegularButton
                  onClick={(e) => handleNextStep(e)}
                  isSubmitting={isSubmitting}
                  label={translate('button.confirm')}
                  type='button'
                  disabled={get(errors, 'emailVerificationCode')}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
        {
          signupPhase === 2 &&
          <Grid>
            <Grid.Row centered style={styles.gridRowPadding}>
              <Grid.Column width={16}>
                <Form.Field>
                  <Field
                    name='username'
                    component={RegularInput}
                    otherProps={{
                      id: 'username',
                      placeholder: translate('form.placeholder.username'),
                      type: 'text',
                      label: translate('form.label.username')
                    }}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={styles.gridRowPadding}>
              <Grid.Column width={16} textAlign='left'>
                <Form.Field>
                  <StyledLabel htmlFor='tags'>{translate('yourTopSkills', { num: 5 })}</StyledLabel>
                  <Field
                    name='tags'
                    component={MultipleSelect}
                    otherProps={{
                      id: 'tags',
                      options: tagOptions,
                      creatable: true,
                      placeholder: translate('tags hint')
                    }}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={styles.gridRowPadding} centered>
              <Grid.Column width={16} textAlign='left'>
                <Form.Field>
                  <Field
                    name='signupRole'
                    component={UserRoleSelect}
                    otherProps={{
                      id: 'signupRole',
                      listItems: userRolesOptions,
                      placeholder: translate('form.title.selectYourRole'),
                      label: translate('form.title.selectYourRole')
                    }}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={styles.gridRowPadding} centered>
              {
                activeLanguage && (!has(values, 'captchaValue') || isEmpty(values.captchaValue)) &&
                <ReCAPTCHA
                  sitekey='6Lfh4dEZAAAAACxqqEHzB0TTYMuhX7ybWCiKQ6Po'
                  onChange={(e) => onChange(e, values)}
                  hl={activeLanguage.code === 'zh-Hans' ? 'zh-CN' : 'en'}
                  style={{ marginBottom: '20px' }}
                />
              }
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <RegularButton
                  isSubmitting={isSubmitting}
                  label={translate('button.next')}
                  disabled={get(errors, 'username') || get(errors, 'tags')}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
      </Container>
    </Form>
  );
};

const Title = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  color: #333333;
`;

const Container = styled.div`
  margin-right: 60px;
  margin-left: 60px;
  margin-top: 40px;
  margin-bottom: 40px;

  .thirdPartiesCol {     
    button {
      @media (max-width: 371px) {
        margin: 10px;
      }
    }
  }
`;

const DescriptionText = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #676767;
`;

const AgreePolicyText = styled.div`
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #999999;
`;


const RegularButton = styled(FormSubmitButton)`
  min-height: 41.13px;
  width: 338px;
  @media (max-width: 768px) {
    width: auto;
  }
`;

const CancelButton = styled(FormSubmitButton).attrs(() => ({
  type: 'button'
}))`
  width: auto;
`;

const PolicyLink = styled.button.attrs(() => ({
  type: 'button'
}))`
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #0095FA;
  border: none;
  background-color: transparent;
`;

const VerificationDescText = styled.div`
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #809FB8;
`;

const LineBorder = styled.hr`
  border: 1px solid #6A7380;
  width: 80px;

  @media (max-width:371px) {
    width: 40px;
  }
`;

const ThirdPartyText = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #6A7380;
`;

const GoogleIcon = styled.button.attrs(() => ({
  type: 'button'
}))`
  background-image: url('/img/icons/thirdParty-google.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
  background-color: #FFFFFF;
  border: none;
`;

const GithubIcon = styled.button.attrs(() => ({
  type: 'button'
}))`
  background-image: url('/img/icons/thirdParty-github.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
  background-color: #FFFFFF;
  border: none;
  margin-right: 80px;
`;

const LinkedinIcon = styled.button.attrs(() => ({
  type: 'button'
}))`
  background-image: url('/img/icons/thirdParty-linkedin.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
  background-color: #FFFFFF;
  border: none;
  margin-left: 80px;
`;

const SendCodeButton = styled(OrginalButton).attrs(() => ({
  type: 'button'
}))`
  min-width: 133px;
  width: 100%;
  margin-bottom: 0.5em;
`;

const ClickableText = styled.button.attrs(() => ({
  type: 'button'
}))`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  color: #0095FA;
  border: none;
  background-color: transparent;
`;

const LoginRedirect = styled(ClickableText)`
  font-weight: 700;
  font-size: 18px;
`;

const StyledLabel = styled.label`
&&&& {
    font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;

  color: #384455 !important;
}
`;

export default compose(
  withLocalize,
  connect(
    ({ user, tags }) => ({ user, tagOptions: tags.tagOptions || [] }),
    {
      signUp, push, accountSignUp, fetchTags, googleLogin, resetGithubState, resetLinkedinState, cancelSocialLogin
    }
  ),
  formikEnhancer
)(AccountSignupForm);



// WEBPACK FOOTER //
// ./src/components/forms/accountSignupForm.js